'use client'

import React from 'react'
import { Phone, Mail } from 'lucide-react'
import { trackPhoneCallInitiated, trackEmailLinkClicked } from '../../lib/analytics'

/** A thin client wrapper that fires analytics when phone/email links are clicked. */
export function FooterContactLinks({
  phoneLink,
  phone,
  emailLink,
  email,
}: {
  phoneLink: string
  phone: string
  emailLink: string
  email: string
}) {
  return (
    <>
      <a
        href={phoneLink}
        onClick={() => trackPhoneCallInitiated()}
        className="flex items-center gap-3 text-white/70 hover:text-white transition-colors text-sm"
      >
        <Phone className="w-4 h-4 shrink-0" />
        {phone}
      </a>
      <a
        href={emailLink}
        onClick={() => trackEmailLinkClicked()}
        className="flex items-center gap-3 text-white/70 hover:text-white transition-colors text-sm"
      >
        <Mail className="w-4 h-4 shrink-0" />
        {email}
      </a>
    </>
  )
}
